import { createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { setTest } from '../actions/test.actions';
import { Test } from '../models/test.model';

export const initialState: Test = null;

const reducer = createReducer(initialState,
  on(setTest, (state, test) => test)
);

export const fromTest = {
  selectTestState: createFeatureSelector<Test>('test'),
};

export function testReducer(state, action) {
  return reducer(state, action);
}
